import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4666a289"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "t" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(".imgBtn { width: 100%; }")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "imgBtn",
  src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/wechat/share/h5_share_open_mdd.png",
  fit: "cover"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("打开App")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_wx_open_launch_weapp = _resolveComponent("wx-open-launch-weapp")!
  const _component_VanButton = _resolveComponent("VanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanImage, {
      class: "bg",
      src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/wechat/share/h5_wechat_bg.png",
      fit: "cover"
    }),
    (_ctx.pageType == `app`)
      ? (_openBlock(), _createBlock(_component_VanImage, {
          key: 0,
          class: "openBtn",
          src: "https://mdd-static.oss-cn-hangzhou.aliyuncs.com/app/h5/h5_download_open_btn.png",
          fit: "cover",
          onClick: _ctx.jumpToApp
        }, null, 8, ["onClick"]))
      : (_openBlock(), _createBlock(_component_wx_open_launch_weapp, {
          key: 1,
          class: "openBtn",
          username: "gh_755cc32889ce",
          path: _ctx.pagePath
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "text/wxtag-template" }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent('style'), null, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })),
                _hoisted_3
              ]),
              _: 1
            }))
          ]),
          _: 1
        }, 8, ["path"])),
    (_ctx.pageType == "openApp")
      ? (_openBlock(), _createBlock(_component_VanButton, {
          key: 2,
          class: "openBtn",
          onClick: _ctx.openApp,
          color: "#FEC64B",
          round: "",
          size: "large"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}